import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setAnnualEnrollmentSettings } from '../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../root/tcsm-model';

export function useAnnualEnrollmentSettings(annualEnrollmentSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.annualEnrollmentSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, annualEnrollmentSettingsId, { guid }, language, false, setAnnualEnrollmentSettings));
		}
	}, []);

	return epiApiState?.annualEnrollmentSettingsState?.contentLoaded;
}